import { jsx, Fragment } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { animated, useTransition, config } from "react-spring";
import Alert from "../../assets/icons/Alert.js";
import { ZIndex } from "../ZIndex.js";
import styled, { keyframes } from "styled-components";
import { SlideInOutRight as SlideInOutRight$1 } from "../SlideInOutRight.js";
const SlideInOutRight = SlideInOutRight$1;
const AnimatedDiv = animated.div;
const spinStretch = keyframes`
  50% {
    transform: rotate(360deg) scale(0.4, 0.33);
    border-width: 4px;
  }
  100% {
    transform: rotate(720deg) scale(1, 1);
    border-width: 2px;
  }
`;
const SpinStretch = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: ${(props) => props.theme.cell.active.spinnerColor};
  border-bottom-color: ${(props) => props.theme.cell.active.spinnerColor};
  border-radius: 50%;
  animation: ${spinStretch} 2s ease infinite;
`;
const AlertWrapper = styled.div`
  height: 16px;
  color: ${(props) => props.theme.cell.warning.color};
`;
const CellActivitySpinner = ({ show, left }) => {
  const isActive = useRef(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [canHideSpinner, setCanHideSpinner] = useState(true);
  const handleShowSpinner = () => {
    if (!isActive.current)
      return;
    setShowSpinner(true);
    setCanHideSpinner(false);
    setTimeout(() => setCanHideSpinner(true), 400);
  };
  useEffect(() => {
    let timeout;
    if (show) {
      isActive.current = true;
      timeout = setTimeout(handleShowSpinner, 100);
    } else {
      isActive.current = false;
      if (!showSpinner && timeout) {
        clearTimeout(timeout);
        timeout = void 0;
      }
    }
  }, [show]);
  useEffect(() => {
    if (!show && canHideSpinner) {
      setShowSpinner(false);
    }
  }, [show, canHideSpinner]);
  if (!showSpinner)
    return null;
  return /* @__PURE__ */ jsx(SlideActivitySpinner, { show: true, left });
};
const SlideActivitySpinner = ({ show, left }) => {
  const position = left ? { left: "-32px", transform: "translate3d(0px, 0px, 0px)" } : { right: "0", transform: "translate3d(32px, 0px, 0px)" };
  const transitions = useTransition(show, {
    config: config.stiff,
    from: {
      zIndex: ZIndex.level500,
      position: "absolute",
      opacity: 0,
      height: "80%",
      width: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ...position
    },
    enter: {
      position: "absolute",
      opacity: 1,
      transform: left ? "translate3d(32px, 0px, 0px)" : "translate3d(0px, 0px, 0px)",
      right: "0"
    },
    leave: {
      position: "absolute",
      opacity: 0,
      transform: left ? "translate3d(0px, 0px, 0px)" : "translate3d(32px, 0px, 0px)"
    }
  });
  return /* @__PURE__ */ jsx(Fragment, { children: transitions(
    (style, item) => item && /* @__PURE__ */ jsx(AnimatedDiv, { style, children: /* @__PURE__ */ jsx(SpinStretch, {}) })
  ) });
};
const SlideAlert = ({ show }) => {
  return /* @__PURE__ */ jsx(SlideInOutRight, { show, children: /* @__PURE__ */ jsx(AlertWrapper, { children: /* @__PURE__ */ jsx(Alert, {}) }) });
};
export {
  CellActivitySpinner,
  SlideActivitySpinner,
  SlideAlert
};
